/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Patient API
 * API for Patient
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PatientReceiptPatientRegistrableTypename = "PatientReceiptPatientRegistrable" as const;

/**
 *
 * @export
 * @interface PatientReceiptPatientRegistrable
 */
export interface PatientReceiptPatientRegistrable {
  /**
   *
   * @type {string}
   * @memberof PatientReceiptPatientRegistrable
   */
  dateOfBirth?: string;
  /**
   *
   * @type {string}
   * @memberof PatientReceiptPatientRegistrable
   */
  gender: PatientReceiptPatientRegistrableGenderEnum;
  /**
   *
   * @type {string}
   * @memberof PatientReceiptPatientRegistrable
   */
  insuredCardCode?: string;
  /**
   *
   * @type {string}
   * @memberof PatientReceiptPatientRegistrable
   */
  insuredCardNumber?: string;
  /**
   *
   * @type {string}
   * @memberof PatientReceiptPatientRegistrable
   */
  insurerNumber?: string;
  /**
   *
   * @type {string}
   * @memberof PatientReceiptPatientRegistrable
   */
  name?: string;
  /**
   *
   * @type {number}
   * @memberof PatientReceiptPatientRegistrable
   */
  pharmacyId: number;
  /**
   *
   * @type {string}
   * @memberof PatientReceiptPatientRegistrable
   */
  receiptCode: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PatientReceiptPatientRegistrable
   */
  readonly __typename?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PatientReceiptPatientRegistrableGenderEnum {
  Male = "male",
  Female = "female",
  None = "none",
}

export function PatientReceiptPatientRegistrableFromJSON(json: any): PatientReceiptPatientRegistrable {
  return PatientReceiptPatientRegistrableFromJSONTyped(json, false);
}

export function PatientReceiptPatientRegistrableFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatientReceiptPatientRegistrable {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PatientReceiptPatientRegistrableTypename,

    dateOfBirth: !exists(json, "date_of_birth") ? undefined : json["date_of_birth"],
    gender: json["gender"],
    insuredCardCode: !exists(json, "insured_card_code") ? undefined : json["insured_card_code"],
    insuredCardNumber: !exists(json, "insured_card_number") ? undefined : json["insured_card_number"],
    insurerNumber: !exists(json, "insurer_number") ? undefined : json["insurer_number"],
    name: !exists(json, "name") ? undefined : json["name"],
    pharmacyId: json["pharmacy_id"],
    receiptCode: json["receipt_code"],
  };
}

export function PatientReceiptPatientRegistrableToJSON(object?: PatientReceiptPatientRegistrable | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    date_of_birth: value.dateOfBirth,
    gender: value.gender,
    insured_card_code: value.insuredCardCode,
    insured_card_number: value.insuredCardNumber,
    insurer_number: value.insurerNumber,
    name: value.name,
    pharmacy_id: value.pharmacyId,
    receipt_code: value.receiptCode,
  };
}
